export default class ParticleEmitter extends PIXI.Container {
	constructor(particleData, particleImages, autoRandomise = false) {
		super();
		this._autoRandomise = autoRandomise;
		this._particles = particleData;
		this._particleImages = particleImages;
		this._config = P3.assets.json(this._particles);
		this._emitter = null;
		this._looping = false;
		this.changeParticle();
		this.visible = false;
	}

	update() {
		if (this._emitter) {
			this._emitter.update(window.dt);
		}
	}

	destroy() {
		if (this._emitter !== null) {
			this._emitter.destroy();
			this._emitter = null;
		}
		this.visible = false;

		return this;
	}

	stop() {
		if (!this._emitter) {
			return this;
		}

		this._emitter.emit = false;

		return this;
	}

	/**
	 * @param {number} duration
	 * @returns {ParticleEmitter}
	 */
	playDuration(duration) {
		if (!this._emitter) {
			return this;
		}

		this.visible = true;
		this._emitter.emit = true;

		setTimeout(() => {
			this._emitter.emit = false;
			this.visible = false;
		}, duration);

		return this;
	}

	play() {
		if (this._emitter === null) {
			this.changeParticle();
		}

		this.visible = true;

		if (this._looping) {
			this._emitter.emitterLifetime = -1;
		}

		this._emitter.emit = true;

		return this;
	}

	changeParticle() {
		if (!this._config) {
			this._config = P3.assets.json(this._particles);
		}
		this._emitter = new PIXI.particles.Emitter(this, this._particleImages, this._config);

		return this;
	}

	enableLoop() {
		this._looping = true;

		return this;
	}

	overrideDefaultConfig(newConfig) {
		this._config = newConfig;
		this.changeParticle();

		return this;
	}
}
